import { GeneralApiResponse } from '../models/http'

export const mockGeneralApiResponse: GeneralApiResponse = {
  success: true,
  msg: 'Pricing schema applied to all listing successfully.',
}
